export default __webpack_public_path__ + "static/media/math-essay-blue.33895655.svg";